"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVOICE_TIME_FORMAT = exports.INVOICE_DATE_FORMAT = void 0;
exports.INVOICE_DATE_FORMAT = 'dd MMMM yyyy';
exports.INVOICE_TIME_FORMAT = 'HH:mm';
//# sourceMappingURL=invoice.js.map